<template>
    <div class="main">
        <c-panel title="IDENTIDADE VISUAL DA INSTITUIÇÃO" titleIcon="fas fa-palette">
            <el-alert title="Estes campos personalizam o cabeçalho/rodapé de todos os relatórios PDF gerados (atas, requerimentos, carteirinhas, etc.). Logo aceita PNG/JPG; cabeçalho/rodapé são HTML."
                type="info" :closable="false" class="u-mb-15"></el-alert>

            <el-form label-position="top" :model="form" ref="formRef" @submit.native.prevent="salvar">
                <el-row :gutter="20">
                    <el-col :sm="10">
                        <el-form-item label="Logo da instituição">
                            <div v-if="form.logo_path" style="margin-bottom:8pt;">
                                <img :src="form.logo_path" style="max-height:80pt; max-width:120pt; border:1px solid #ddd; padding:4pt;" />
                                <div style="font-size:12px; color:#909399; margin-top:4pt;">{{ form.logo_nome }}</div>
                                <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="removerLogo">REMOVER</el-button>
                            </div>
                            <el-upload v-if="!form.logo_path"
                                :action="`${baseUrl()}/api/file/upload-file/${instId() || 0}`"
                                :headers="{ Authorization: 'Bearer ' + token() }"
                                :on-success="onUploadSuccess"
                                :on-error="onUploadError"
                                :before-upload="beforeUpload"
                                accept="image/*"
                                :limit="1">
                                <el-button type="primary" icon="el-icon-upload">SELECIONAR LOGO</el-button>
                                <div slot="tip" style="font-size:12px; color:#909399;">PNG ou JPG até ~500KB recomendado.</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="6">
                        <el-form-item label="Cor primária (hex)">
                            <el-input v-model="form.cor_primaria" placeholder="#0b5394" maxlength="7">
                                <template slot="prepend">#</template>
                            </el-input>
                            <div :style="`width:100%; height:20pt; background:${form.cor_primaria || '#0b5394'}; margin-top:6pt; border-radius:3pt;`"></div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Cabeçalho personalizado (HTML opcional)">
                    <el-input type="textarea" v-model="form.cabecalho_personalizado" :rows="3" placeholder="<em>Secretaria Municipal de Educação — Sistema SMGE</em>"></el-input>
                </el-form-item>

                <el-form-item label="Rodapé personalizado (HTML opcional)">
                    <el-input type="textarea" v-model="form.rodape_personalizado" :rows="2" placeholder="Documento emitido eletronicamente. Confira a autenticidade em ..."></el-input>
                </el-form-item>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <el-button type="primary" native-type="submit">SALVAR PERSONALIZAÇÃO</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data () {
        return { form: { logo_path: null, logo_nome: null, logo_mime: null, logo_size: null, cabecalho_personalizado: '', rodape_personalizado: '', cor_primaria: '' } }
    },
    mounted () { this.carregar() },
    watch: {
        '$store.state.config.instituicao.id' () { this.carregar() }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        instId () { const i = this.$store.state.config.instituicao; return i && i.id ? i.id : null },
        token () { return this.$store.state.token },

        carregar () {
            if (!this.instId()) return
            this.$axios.get(`${this.baseUrl()}/api/instituicao-personalizacao/get/${this.instId()}`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    const reg = r.data || {}
                    this.form = {
                        logo_path: reg.logo ? reg.logo.path : null,
                        logo_nome: reg.logo ? reg.logo.nome : null,
                        logo_mime: reg.logo ? reg.logo.mime : null,
                        logo_size: reg.logo ? reg.logo.size : null,
                        cabecalho_personalizado: reg.cabecalho_personalizado || '',
                        rodape_personalizado:    reg.rodape_personalizado || '',
                        cor_primaria:            reg.cor_primaria || ''
                    }
                })
        },
        beforeUpload (file) {
            this.form.logo_nome = file.name
            this.form.logo_mime = file.type
            this.form.logo_size = file.size
            return true
        },
        onUploadSuccess (res) {
            if (res && res.url) {
                this.form.logo_path = res.url
                window.eventBus.$emit('alert', { msg: 'Logo enviada. Não esqueça de clicar em SALVAR.', type: 'success' })
            }
        },
        onUploadError () {
            window.eventBus.$emit('alert', { msg: 'Erro no upload da logo.', type: 'error' })
        },
        removerLogo () {
            this.$confirm('Remover a logo atual?', 'Confirmar', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/instituicao-personalizacao/removerLogo/${this.instId()}`, this.$store.getters.getHeaderAuth)
                    .then(() => {
                        this.form.logo_path = null
                        this.form.logo_nome = null
                        window.eventBus.$emit('alert', { msg: 'Logo removida.', type: 'success' })
                    })
            }).catch(() => {})
        },
        salvar () {
            if (!this.instId()) { window.eventBus.$emit('alert', { msg: 'Selecione uma instituição no header.', type: 'warning' }); return }
            const payload = { ...this.form }
            if (payload.cor_primaria && payload.cor_primaria[0] !== '#') payload.cor_primaria = '#' + payload.cor_primaria
            this.$axios.post(`${this.baseUrl()}/api/instituicao-personalizacao/salvar/${this.instId()}`, payload, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Personalização salva.', type: 'success' })
            })
        }
    }
}
</script>
